import React, { useState } from 'react';
import './../css/ImageWithLoader.css';

const ImageWithLoader = ({ src, alt, className }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={`image-container ${className || ''}`}>
      {!loaded && <div className="image-placeholder"></div>}
      <img
        src={src}
        alt={alt}
        className={`fade-image ${loaded ? 'loaded' : ''}`}
        onLoad={() => setLoaded(true)}
        loading="lazy"
      />
    </div>
  );
};

export default ImageWithLoader;
